
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Apps</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>Wählen Sie eine App aus oder erstellen Sie eine neue.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-text>
                          Neue App
                          <h3 class="headline">Bitte füllen Sie alle Felder aus</h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Name"
                            outlined
                            label="App Name"
                            v-model="app.name"
                          ></v-text-field>
                          <v-color-field
                            placeholder="Primär Farbe"
                            label="Primär Farbe"
                            v-model="app.color1"
                          ></v-color-field>
                          <v-color-field
                            class="pt-5"
                            v-model="app.color2"
                            placeholder="Sekundär Farbe"
                            label="Sekundär Farbe"
                          ></v-color-field>
                          <v-text-field
                            class="pt-5"
                            placeholder="API Key"
                            outlined
                            counter="36"
                            label="API Key"
                            v-model="app.apiKey"
                            @click:append="generateApiKey"
                            append-icon="mdi-wrench"
                          ></v-text-field>
                        </v-card-text>

                        <v-card-actions class="justify-center">
                          <v-btn
                            :disabled="imageData == null"
                            large
                            color="primary"
                            @click="create"
                          >WEITER</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-10">
                      <v-row class="mb-5">
                        <h2>Lade ein Logo hoch</h2>
                      </v-row>
                      <v-row>
                        <v-image-input
                          v-model="imageData"
                          :image-quality="1"
                          imageMinScaling="contain"
                          clearable
                          image-format="png"
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import AppService from "@/services/AppService";
import AssetService from "@/services/AssetService";
import ColorField from "@/views/general/components/ColorPicker";

export default {
  name: "dashboard",
  components: {
    Header: Header,
    "v-color-field": ColorField
  },
  data: () => ({
    loading: true,
    imageData: null,
    error: null,
    app: {
      name: "",
      apiKey: "",
      color1: "#000000",
      color2: "#000000",
      url: "",
      assetId: null
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    generateApiKey() {
      this.app.apiKey = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );

      return true;
    },
    async uploadImage() {},
    async create() {
      try {
        let payload = this.app;


        this.loading = true;
        payload.imageId = (await AssetService.upload(this.imageData)).data.id;

        await AppService.create(payload);
        this.loading = false;
        router.push({ name: "Apps" });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

